export default __webpack_public_path__ + "static/aboutimg-9408bbde21e2a827c6d77f7314030427.png";